// extracted by mini-css-extract-plugin
export default {"btn":"CloseButton_btn__n7IXe","large":"CloseButton_large__s1-J1","invert":"CloseButton_invert__Yk2B7","muted":"CloseButton_muted__0C8Fo","border":"CloseButton_border__EDlUi"};